import {useState} from "react";
import "../Styles/CourseRegistrationForm.css";

function CourseRegistrationForm({onClose}) {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const [isFormValid, setIsFormValid] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        const formattedValue = name === "phone" ? value.replace(/\D/g, "") : value;

        setFormData((prev) => {
            const updatedData = {...prev, [name]: formattedValue};
            validateForm(updatedData);
            return updatedData;
        });
    };

    const validateForm = (data) => {
        const isValidName = data.name.trim() !== "";
        const isValidEmail = /\S+@\S+\.\S+/.test(data.email);
        const isValidPhone = /^\d{10}$/.test(data.phone);
        setIsFormValid(isValidName && isValidEmail && isValidPhone);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Kurs Kaydı Başarıyla Tamamlandı!\n" + JSON.stringify(formData, null, 2));
        onClose(); // **Form başarılı olunca modal kapansın**
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h2>Kurs Kayıt Formu</h2>
                <form onSubmit={handleSubmit} className="course-registration-form">
                    <div>
                        <label>İsim:</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} required/>
                    </div>

                    <div>
                        <label>Email:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required/>
                    </div>

                    <div>
                        <label>Telefon Numarası:</label>
                        <input type="text" name="phone" value={formData.phone} onChange={handleChange} maxLength="10"
                               placeholder="5551234567" required/>
                    </div>

                    <button type="submit" className={`submit-button ${isFormValid ? "active" : "disabled"}`}
                            disabled={!isFormValid}>
                        Kaydol
                    </button>
                    <button type="button" className="cancel-button" onClick={onClose}>
                        İptal
                    </button>
                </form>
            </div>
        </div>
    );
}

export default CourseRegistrationForm;
